export default function PrivacyPolicy() {
  return (
    <div className="container my-5">
      <h1 className="mb-4">Általános Adatkezelési Tájékoztató</h1>
      <p>Hatályos: 2025. december 18.</p>
      <p>
        A jelen tájékoztató célja, hogy áttekintést nyújtson az Ön személyes
        adatainak kezeléséről, amikor igénybe veszi szolgáltatásainkat.
        Adatkezelőként a <strong className="h5">Smart Financials Kft</strong>{" "}
        (székhely: 2014 Csobánka, Kilátó utca 4., adószám: 32893841-2-13,
        cégjegyzékszám: 13 09 242660, e-mail: financials@financials.hu) jár el.
      </p>

      <h2 className="mt-4">1. Az adatkezelés jogalapja</h2>
      <p>
        Az Ön személyes adatait a GDPR, az információs önrendelkezési jogról
        szóló 2011. évi CXII. törvény, valamint egyéb vonatkozó magyar
        jogszabályok alapján kezeljük. Az adatkezelés jogalapja lehet:
        <ul>
          <li>az Ön hozzájárulása</li>
          <li>jogszabályi kötelezettség teljesítése;</li>
          <li>szerződés teljesítése;</li>
          <li>
            jogos érdekünk, például ügyfélkapcsolat fenntartása, csalás
            megelőzése, hirdetések és marketing célú tájékoztatás.
          </li>
        </ul>
      </p>

      <h2 className="mt-4">2. Kezelt adatok köre</h2>
      <p>
        Kezelt adatok lehetnek többek között:
        <ul>
          <li>név</li>
          <li>e-mail cím</li>
          <li>telefonszám</li>
          <li>a szolgáltatás igénybevételéhez szükséges pénzügyi adatok</li>
          <li>
            a weboldal használata során keletkező, nem személyhez kapcsolódó
            adatok (pl. sütik)
          </li>
        </ul>
      </p>

      <h2 className="mt-4">3. Az adatkezelés célja</h2>
      <p>
        Adatainak feldolgozása az alábbi célokra történhet:
        <ul>
          <li>Szolgáltatások nyújtása és teljesítése</li>
          <li>Ügyfélazonosítás, ügyfélátvilágítás</li>
          <li>Kapcsolattartás, tájékoztatás, hírlevél küldés</li>
          <li>Marketing, promóciók, ajánlatok küldése</li>
          <li>Weboldal és szolgáltatások fejlesztése</li>
          <li>Jogi, adójogi, számviteli kötelezettségek teljesítése</li>
          <li>Csalások megelőzése és az adatbiztonság fenntartása</li>
        </ul>
      </p>
      <h2 className="mt-4">4. Adattovábbítás</h2>
      <p>
        Személyes adatait az adatkezelő által megjelölt partnereknek
        továbbíthatjuk, amennyiben ez a szolgáltatás nyújtásához szükséges, vagy
        Ön ehhez hozzájárul.
      </p>
      <h2 className="mt-4">5. Adatmegőrzés időtartama</h2>
      <p>
        Az adatkezelés időtartama a jogszabályi kötelezettségektől, szerződéses
        feltételektől vagy az Ön hozzájárulásától függ. A kötelező adatkezelés
        esetén az adatokat a jogszabályok által előírt ideig, egyéb esetekben a
        hozzájárulás visszavonásáig kezeljük.
      </p>
      <h2 className="mt-4">6. Érintett jogok</h2>
      <p>
        Ön jogosult:
        <ul>
          <li>hozzáférni adataihoz;</li>
          <li>kérni azok helyesbítését;</li>
          <li>kérni adatai törlését;</li>
          <li>kezelésének korlátozását;</li>
          <li>tiltakozni adatkezelés ellen;</li>
        </ul>
        valamint az adathordozhatósághoz való jogot gyakorolni. A hozzájárulást
        bármikor visszavonhatja, anélkül, hogy ez befolyásolná a jogszerűen
        kezelt adatok kezelését a visszavonás előtt.
      </p>
      <h2 className="mt-4">7. Kapcsolat</h2>
      <p>
        Adatvédelmi kérdésekkel, panasszal a{" "}
        <strong>financials@financials.hu</strong> címen, vagy postai úton a{" "}
        <strong>2014 Csobánka, Kilátó utca 4.</strong> címen fordulhat hozzánk.
      </p>
    </div>
  );
}
